// Currency utility functions for country-to-currency mapping

// Country to currency mapping
export const COUNTRY_CURRENCY_MAP = {
  'Nigeria': {
    symbol: '₦',
    code: 'NGN',
    name: 'Nigerian Naira'
  },
  'Ghana': {
    symbol: '₵',
    code: 'GHS',
    name: 'Ghanaian Cedi'
  },
  'South Africa': {
    symbol: 'R',
    code: 'ZAR',
    name: 'South African Rand'
  },
  'Kenya': {
    symbol: 'KSh',
    code: 'KES',
    name: 'Kenyan Shilling'
  },
  'United Kingdom': {
    symbol: '£',
    code: 'GBP',
    name: 'British Pound'
  },
  'UK': {
    symbol: '£',
    code: 'GBP',
    name: 'British Pound'
  }
};

// Default currency for any other country
export const DEFAULT_CURRENCY = {
  symbol: '$',
  code: 'USD',
  name: 'US Dollar'
};

// Get currency info for a country
export const getCurrencyForCountry = (country) => {
  if (!country) return DEFAULT_CURRENCY;
  
  // Check exact match first
  if (COUNTRY_CURRENCY_MAP[country]) {
    return COUNTRY_CURRENCY_MAP[country];
  }
  
  // Check case-insensitive match
  const countryKey = Object.keys(COUNTRY_CURRENCY_MAP).find(
    key => key.toLowerCase() === country.toLowerCase()
  );
  
  if (countryKey) {
    return COUNTRY_CURRENCY_MAP[countryKey];
  }
  
  // Return default currency for any other country
  return DEFAULT_CURRENCY;
};

// Format currency amount
export const formatCurrency = (amount, country = null) => {
  if (amount === null || amount === undefined) return '0';
  
  const currency = getCurrencyForCountry(country);
  const numericAmount = parseFloat(amount) || 0;
  
  // Format with appropriate decimal places
  const formattedAmount = numericAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  
  return `${currency.symbol}${formattedAmount}`;
};

// Get currency symbol only
export const getCurrencySymbol = (country = null) => {
  const currency = getCurrencyForCountry(country);
  return currency.symbol;
};

// Get currency code only
export const getCurrencyCode = (country = null) => {
  const currency = getCurrencyForCountry(country);
  return currency.code;
};

// Get currency name only
export const getCurrencyName = (country = null) => {
  const currency = getCurrencyForCountry(country);
  return currency.name;
};

// Check if country is supported for payments
export const isSupportedCountry = (country) => {
  if (!country) return false;
  
  return Object.keys(COUNTRY_CURRENCY_MAP).some(
    key => key.toLowerCase() === country.toLowerCase()
  );
};

// Get list of supported countries for selection
export const getSupportedCountries = () => {
  return [
    { name: 'Nigeria', currency: '₦ (NGN)' },
    { name: 'Ghana', currency: '₵ (GHS)' },
    { name: 'South Africa', currency: 'R (ZAR)' },
    { name: 'Kenya', currency: 'KSh (KES)' },
    { name: 'United Kingdom', currency: '£ (GBP)' },
    { name: 'Other', currency: '$ (USD)' }
  ];
};

// Validate country selection
export const validateCountrySelection = (country) => {
  if (!country) {
    return { isValid: false, message: 'Please select a country' };
  }
  
  if (country === 'Other') {
    return { isValid: true, message: 'Using default currency (USD)' };
  }
  
  return { isValid: true, message: `Currency set to ${getCurrencyForCountry(country).name}` };
};